import * as React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { Survey } from './TableSurveysRow';
import { TeamOfTeamsAnalysisData } from './TeamOfTeamsAnalysis';

export interface TeamOfTeams {
  id: string;
  surveys: Survey[];
  analysis: TeamOfTeamsAnalysisData;
}

interface TableTeamOfTeamsRowProps {
  row: TeamOfTeams;
  setAnalysisModalOpen: (teamOfTeams: TeamOfTeams | null) => void;
}

export const TableTeamOfTeamsRow: React.FC<TableTeamOfTeamsRowProps> = ({
  row,
  setAnalysisModalOpen,
}) => {
  const [open, setOpen] = React.useState(false);
  const openRow = (openState: boolean) => {
    setOpen(openState);
  };
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} hover>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              openRow(!open);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell scope="row">{row.id}</TableCell>
        <TableCell>
          <Button
            variant="outlined"
            onClick={() => {
              setAnalysisModalOpen(row);
            }}
          >
            Show analysis
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <TableRow key={row.id}>
                <TableCell sx={{ borderBottom: 0 }} scope="row">
                  {JSON.stringify(row.surveys.map((s) => s.t))}
                </TableCell>
              </TableRow>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
